import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { WizardData, LoadWizardData, SaveWizardData, categories } from './Model';
import { BackButton } from '@/components/layout/NavBar';
import { FilesProvider, SimpleFiles } from '@/components/forms/common/files/files';
import { Stream } from '@/services/common/stream';
import * as osfiles from "@/components/forms/common/osfiles"

const API_BASE = "/api/public/tmp/files"

/* Select category */

export const SupportWizardStep1 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const [translates, setTranslates] = useState<Translates>()
  const [wizardData, setWizardData] = useState<WizardData>(LoadWizardData())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='support-wizard' services={services} translates={translates} session={session}
    navbarLeft={
      <BackButton
        services={services}
        translates={translates}
      />
    }>

    <h2 className='page-title'>{translates.for(`wizards.support_question.title`)}</h2>

    {categories.map(row => <div className={`main-btn ${wizardData.categoryId === row.id ? 'selected' : ''}`} onClick={() => {
      const newData: WizardData = {
        ...wizardData,
        categoryId: row.id,
        issueId: row.id !== wizardData.categoryId ? undefined : wizardData.issueId
      }
      setWizardData(newData)
      SaveWizardData(newData)
      navigate(`/communal/support/wizard/page2`, { replace: true })
    }}>{translates.for(`wizards.support_question.categories.${row.id}`)}</div>)}

    {/* <div className='approve-btn' onClick={() => {
      SaveWizardData(wizardData)
      navigate(`//files/upload/page2`, { replace: true })
    }}>
      {translates.for(`wizards.support_question.next`)}
    </div> */}

  </MainPageLayout>
}
